import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-metric-card',
  imports: [MatIcon],
  templateUrl: './metric-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './metric-card.component.css',
})
export class MetricCardComponent {
  title = input.required<string>();
  icon = input<string>();
  hasChart = input<boolean>(false);
}
